import { Component, ElementRef, OnInit, Self, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Paystub } from '@app/models/payroll/company/paystub.model';
import { Payroll } from '@app/models/payroll/payroll.model';
import { ShowView } from '@common/views';
import { PaystubLazyLoadService } from '@payroll/services';

type PayrollDetailsDialogType = 'PAYSTUB_DETAILS' | 'OTHER_REMITTANCES';

@Component({
    templateUrl: './payroll-details.template.html',
    styleUrls: ['./payroll-details.style.scss'],
    providers: [PaystubLazyLoadService],
})
export class PayrollDetailsView extends ShowView implements OnInit {
    @ViewChild('scrollAnchor') scrollAnchor!: ElementRef<HTMLElement>;

    isLoading = true;
    isLazyLoading = false;
    payroll: Payroll;
    activePaystub?: Paystub;
    currentlyOpenDialog?: PayrollDetailsDialogType;

    private scrollObserver?: IntersectionObserver;

    constructor(
        private route: ActivatedRoute,
        @Self() public paystubService: PaystubLazyLoadService
    ) {
        super();
        this.payroll = this.route.snapshot.data.models.get('payroll');
    }

    async ngOnInit(): Promise<void> {
        this.paystubService.setPayroll(this.payroll);
        await this.paystubService.load();

        this.enableLazyLoadScrolling();

        this.isLoading = false;
    }

    onSave(): void {}
    onCancel(): void {}
    onDelete(): void {}

    get showQcRemittances(): boolean {
        return this.payroll.hasQcRemittances;
    }

    private enableLazyLoadScrolling(): void {
        setTimeout(() => {
            this.scrollObserver = new IntersectionObserver(async ([entry]) => {
                if (!entry.isIntersecting) {
                    return;
                }

                if (!this.paystubService.hasMore) {
                    return;
                }

                if (this.isLazyLoading) {
                    return;
                }

                this.isLazyLoading = true;
                await this.paystubService.loadMore();

                this.isLazyLoading = false;
            });

            this.scrollObserver.observe(this.scrollAnchor.nativeElement);
        });
    }
}
